export default {
    setAuth: (state, {user, token, token_type, expires_in, role_name, permissions} ) => {
        state.userState.auth = user;
        state.userState.token = token;
        state.userState.tokenType = token_type;
        state.userState.expiresIn = expires_in;
        state.userState.role_name = role_name;
        state.userState.permissions = permissions;
    },
    clearAuth: (state,  ) => {
        state.userState.auth = null;
        state.userState.token = null;
        state.userState.tokenType = null;
        state.userState.expiresIn = null;
        state.userState.role_name = null;
        state.userState.permissions = [];
    },
    setLoginLoading: (state, loading ) => {
        state.userState.loginLoading = loading;
    },
    setCommonErrors (state, errors) {
        state.commonState.commonErrors = errors;
    },
    setErrorMessage (state, msg) {
        state.commonState.errorMessage = msg;
    },
    setSuccessMessage (state, msg) {
        state.commonState.successMessage = msg;
    },
    setExportFile (state, exportFile) {
        state.commonState.exportFile = exportFile;
    },
    setLoading: (state, loading ) => {
        state.commonState.loading = loading;
    },
    setSettings (state, settings) {
        state.commonState.settings = settings;
    },
    setDashboardTarget (state, dashboardTarget) {
        state.commonState.dashboardTarget = dashboardTarget;
    },
    setDashboardTargetUser (state, dashboardTargetUser) {
        state.commonState.dashboardTargetUser = dashboardTargetUser;
    },
    setProductsLoading: (state, loading ) => {
        state.commonState.productsLoading = loading;
    },
    setQuoteProductsLoading: (state, loading ) => {
        state.commonState.quoteProductsLoading = loading;
    },
    setCarriers: (state, carriers ) => {
        state.commonState.carriers = carriers;
    },
    setQuotationLoading: (state, loading ) => {
        state.quotationState.quotationsLoading = loading;
    },
    setQuotations: (state, quotations ) => {
        state.quotationState.quotations = quotations;
    },
    setNewQuotation: (state, newQuotation ) => {
        state.quotationState.newQuotation = newQuotation;
    },
    setPriceCalculation: (state, priceCalculation ) => {
        state.quotationState.priceCalculation = priceCalculation;
    },
    setQuotationsFilter: (state, filter ) => {
        state.quotationState.filter = filter;
    },
    setCustomerLoading: (state, loading ) => {
        state.customerState.customersLoading = loading;
    },
    setCustomers: (state, customers ) => {
        state.customerState.customers = customers;
    },
    setVendorFilter: (state, filter ) => {
        state.commonState.vendorFilter = filter;
    },
    setOrders: (state, orders ) => {
        state.salesOrderState.orders = orders;
    },
    setNewOrder: (state, newOrder ) => {
        state.salesOrderState.newOrder = newOrder;
    },
    setOrdersShowFilters: (state, showFilters ) => {
        state.salesOrderState.showFilters = showFilters;
    },
    setOrdersFilterData: (state, filterData ) => {
        state.salesOrderState.filterData = filterData;
    },
    setSalesOrderMenuItems: (state, menuItems ) => {
        state.salesOrderState.menuItems = menuItems;
    },

    setOrdersLoading: (state, ordersLoading ) => {
        state.salesOrderState.ordersLoading = ordersLoading;
    },
    setOrderMaxNumOfShipToAddress: (state, maxNumOfShipToAddress ) => {
        state.salesOrderState.maxNumOfShipToAddress = maxNumOfShipToAddress;
    },
    setPurchaseOrders: (state, orders ) => {
        state.purchaseOrderState.orders = orders;
    },
    setNewPurchaseOrder: (state, newOrder ) => {
        state.purchaseOrderState.newOrder = newOrder;
    },
    setPurchaseOrdersLoading: (state, ordersLoading ) => {
        state.purchaseOrderState.ordersLoading = ordersLoading;
    },
    setPurchaseOrdersShowFilters: (state, showFilters ) => {
        state.purchaseOrderState.showFilters = showFilters;
    },
    setPurchaseOrdersFilterData: (state, filterData ) => {
        state.purchaseOrderState.filterData = filterData;
    },
    setPurchaseOrderMenuItems: (state, menuItems ) => {
        state.purchaseOrderState.menuItems = menuItems;
    },

    setTaskShowFilters: (state, showFilters ) => {
        state.taskState.showFilters = showFilters;
    },
    setTaskFilterData: (state, filterData ) => {
        state.taskState.filterData = filterData;
    },

    setReminderShowFilters: (state, showFilters ) => {
        state.reminderState.showFilters = showFilters;
    },
    setReminderFilterData: (state, filterData ) => {
        state.reminderState.filterData = filterData;
    },
    resetState: (state ) => {
        state.userState = _.cloneDeep(state.initialState.userState);
        state.quotationState = _.cloneDeep(state.initialState.quotationState);
        state.customerState = _.cloneDeep(state.initialState.customerState);
        state.salesOrderState = _.cloneDeep(state.initialState.salesOrderState);
        state.purchaseOrderState = _.cloneDeep(state.initialState.purchaseOrderState);
        state.taskState = _.cloneDeep(state.initialState.taskState);
        state.reminderState = _.cloneDeep(state.initialState.reminderState);
        state.commonState = _.cloneDeep(state.initialState.commonState);
    },
    backShipmentState: (state, loadingData ) => {
        state.backState.loading = loadingData;
    },
}
